import joi from 'joi';
import { makeDefinitionFor } from '../../../helpers/endpoint.definition.details.generator';
import { generateValidationError, success } from '../../../shared/api.response.def';
import { department } from '../../../shared/department.def';

const response = joi.object({
	results: joi.array().items(department),
});

export const definition = makeDefinitionFor(
	'/department.json',
	{
		description: 'Get a list of departments the user has access to',
		method: 'get',
		summary: 'Department list',
		tags: ['Department'],
	},
	[
		{
			code: 200,
			description: success,
			schema: response,
		},
		generateValidationError(),
	]
);
